'use client'

import { CookieConsentProvider as OriginalCookieConsentProvider } from '@use-cookie-consent/react'
import React from 'react'

export function CookieConsentClientProvider({ children }: { children: React.ReactNode }) {
  return (
    <OriginalCookieConsentProvider
      useCookieConsentHooksOptions={{ consentCookieAttributes: { expires: 365 } }}
    >
      {children}
    </OriginalCookieConsentProvider>
  )
}
